enum Direction {
    ROW = 'row',
    COLUMN = 'column'
}

export default Direction;
